import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ChartService } from 'src/app/services/charts/charts.service';
import { Chart, registerables } from 'chart.js';
import { MetadataService } from 'src/app/services/metadata/metadata.services';
Chart.register(...registerables);

@Component({
  selector: 'app-polar-chart',
  templateUrl: './polar-chart.component.html',
  styleUrls: ['./polar-chart.component.scss']
})
export class PolarChartComponent implements OnInit, AfterViewInit {
  @Input() title = '';
  @Input() chartId: any;
  @Input() chartCategory: any;
  @Input() subscribed: any;
  @Input() wideMode = false;
  @Input() description = '';
  @Input() legend = true;

  public dataSets: any;
  public chart: any;
  public labels: any;
  public colors: any;
  isEmpty = false;

  @ViewChild('chartCanvas') canvasEl!: ElementRef<HTMLCanvasElement>;

  constructor(
    private chartService: ChartService,
    private meta: MetadataService,
  ) { }

  ngOnInit(): void {
    //this.getChartData();
  }

  ngAfterViewInit() {
    this.getChartData();
    this.initChart();
  }

  getChartData() {
    this.dataSets = this.chartService.getChartDataByCategory(this.chartCategory);
    this.labels = this.meta.getChartLabels(this.chartCategory);
    this.colors = this.meta.getChartColors(this.chartCategory);
    this.isEmpty = this.dataSets.every((value:number ) => value === 0);

    //setTimeout(() => {
    //  this.initChart();
    //}, 100);
  }

  initChart() {
    if (!this.canvasEl) {
      console.warn('Canvas not ready yet');
      return;
    }
    const ctx = this.canvasEl.nativeElement.getContext('2d');
    if (!ctx) {
      console.error('No se pudo obtener el contexto del canvas');
      return;
    }
    const canvas: any = document.getElementById(this.chartId);
    const ctx2 = canvas.getContext("2d");

    this.chart = new Chart(ctx2, {
      type: 'polarArea',
      data: {
        labels: this.labels,
        datasets: [
          {
            data: this.dataSets,
            backgroundColor: this.colors.background,
            borderColor: this.colors.borders
          }
        ]
      },

      options: {
        responsive: true,
        // maintainAspectRatio: true,
        scales: {
          r: {
            ticks: {
              display: false,
              maxTicksLimit: 11
            },
            angleLines: {
              color: '#aaa'
            },
            grid: {
              color: '#ccc',
            },
            pointLabels: {
              color: '#666',
              font: {
                size: 12,
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false,
            position: 'right',
            labels: {
              color: '#777',
              font: {
                size: 12,
              },
              padding: 15,
              pointStyle: 'circle',
              usePointStyle: true,
              boxHeight: 6,
              boxWidth: 6
            }
          },
          datalabels: {
            display: true,
            color: '#FFFFFF',
            font: {
              size: 12,
            },
          },
        }
      },
    });
  }

  reInitChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.getChartData();
    this.initChart();
  }
}
